<template>
    <div class="modal-window mas013 mas_cal mas_cal_list" >
        <header class="modal-header">
            <div class="tit">상세 목록 {{ $moment(modalInfo.selectDate).format("(YYYY년 MM월 DD일)") }}
            
                <!-- 보드 목록 -->
                <select v-model="selectPaperId" class="sel_ty1 txt-01" @change="monthToData">
                    <option value="ALL">전체</option>
                    <option value="">공통</option>
                    <option v-for="paper in paperList"
                    :value="paper.paperId"
                    :key="paper.paperId">{{ paper.paperTitle }}</option>
                </select>
            </div>
            <button @click="$emit('close')" class="btn_close">닫기</button>
        </header>
        
        <div class="modal-content">
            <div class="detail-sche-list-box">
                <div class="item" 
                v-for="(todo, index) in todoList" :key="index"
                @click="MAS_Cal_Detail_Edit(todo.todoMainId)">
                    <div class="cal-tit-txt-box">
                        {{ todo.paperId == '' ? '공통' : todo.paperTitle }}
                        <div v-if="todo.regUserName" style="float: right;padding: 5px 20px; font-size: 90%;">작성자 : {{ todo.regUserName }}</div>
                    </div>
                    <ul class="list-table">
                        <li>
                            <dl>
                                <dt>제목</dt>
                                <dd style="word-break: break-word;">
                                    <div class="cal-date-txt-box">
                                        <div> {{ todo.todoTitle }} </div>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <dl>
                                <dt>장소/위치</dt>
                                <dd style="word-break: break-word;">
                                    <div class="cal-date-txt-box">
                                        <div> {{ todo.todoLocation }}</div>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <dl>
                                <dt>내용</dt>
                                <dd style="word-break: break-word;">
                                    <div class="cal-date-txt-box">
                                        <div>{{ todo.todoContent }}</div>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        <li>
                            <dl>
                                <dt>일정</dt>
                                <dd>
                                    <div class="cal-date-txt-box">
                                        <div> {{ $moment(todo.todoStartDatetime == null ? todo.todoStartDate : todo.todoStartDatetime).format('YYYY년 MM월 DD일 HH시 mm분 ') }} – 
                                            {{ $moment(todo.todoEndDatetime == null ? todo.todoEndDate : todo.todoEndDatetime).format('YYYY년 MM월 DD일 HH시 mm분') }} </div>
                                    </div>
                                </dd>
                            </dl>
                        </li>
                        
                    </ul>
                </div>
            </div>
            
        </div>

        <footer class="modal-footer">
            <div class="button-align-cal">
                <div></div>
                <div>
                    <button type="button" class="btn_ty2 btn_add" @click="MAS_Cal_Detail_Edit()">신규일정 등록하기</button>
                </div>
                
                
            </div>
        </footer>
    </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import Datepicker from 'vuejs-datepicker';
import EventBus from "@/js/eventbus/eventBus";
import MAS_Cal_Detail from "@/components/cowork/general/calendar/modal/MAS_Cal_Detail";

export default {
    components: {
        Datepicker
    },
    props: {
        modalInfo: {
            type: Object,
        },
    },
    data() {
        return { 
            todoList: [],
            paperList: [],
            selectPaperId: this.modalInfo.paperId,
        };
    },
    mounted() {
        this.getBoardAllList();
        this.monthToData();
    },
    created() {
        EventBus.$off("refreshTodoList");
        EventBus.$on("refreshTodoList", () => {
            this.monthToData();
        });
    },
    methods: {  
        ...mapActions("modals", ["showModal"]),
        ...mapActions("restAction", ["COWORK_REST_ACTION", "COWORK_REST_SIMPLE_ACTION"]),
        MAS_Cal_Detail_Edit(todoMainId) {
            const modalInfo = {
                title: "일정 수정 팝업",
                width: "800px",
                height: "600px",
                obj: this.$modal,
                component: MAS_Cal_Detail,
                projectId: this.modalInfo.projectId,
                selectDate: this.modalInfo.selectDate,
                todoMainId: todoMainId
            };
            this.showModal(modalInfo);
        },
        getBoardAllList() {
            let obj = this;
            let param = {
                url: '/api/copaper/paper/getProjectPaperList',
                method: 'post',
                req: {
                    projectId: this.modalInfo.projectId,
                    limitRow: 400,
                    page: 0,
                    sortKey: 'paperTitle',
                    sortDesc: [true],
                }
            };
            obj.COWORK_REST_ACTION(param)
                .then((res) => {
                    paperList: [];
                    if (res.errorCode == null) {
                        obj.paperList = res.result.paperList.content;
                    }
                })
                .catch(function (err) {
                    console.log(err);
                });
        },
        monthToData() {
            let obj = this;
            let reqData = {};
            reqData.params = {
                projectId: this.modalInfo.projectId,
                paperId: this.selectPaperId,
                startDate: this.modalInfo.selectDate,
                endDate: this.modalInfo.selectDate,
            };
            reqData.req = obj.req;
            reqData.url = "/api/copaper/todo/monthToData";
            reqData.method = "post";

            obj.COWORK_REST_SIMPLE_ACTION(reqData).then((response) => {
                let res = response.result;
                let todos = res.todoMonth;
                this.todoList = [];

                for (let todokey in todos) {
                    let subList = todos[todokey];

                    for (let index in subList) {
                        let todo = subList[index];
                        this.todoList.push(todo);
                    }
                }
            });
        },
    },
}
</script>


// WEBPACK FOOTER //
// src/components/cowork/general/calendar/modal/MAS_Cal_List.vue